/*
 * @Author: wangzhu
 * @LastEditors: wangzhu
 * @Date: 2020-12-02 20:04:38
 * @LastEditTime: 2020-12-02 20:14:07
 * @Description: File description
 */
import authApi from '@/services/auth'
import store from '@/store'
import { getPermissions, getLearnPermissions, getMarketCenterPermissions, removeFromUrl, getUser } from '@/services/auth/utils'

function linkRouter (link, config) {
  if (typeof link === 'function') {
    link(config)
  } else {
    link.push(config)
  }
}

/**
 * @param link: next or router
 * @param options: to or route
 * @param category: 区别直播云or魔法校
 */
export default (link, options, category) => {
  authApi.getUserPermissions().then(async res => {
    store.dispatch('queryAdverse', {
      type: 1,
      show_position: 3
    })
    removeFromUrl()
    // 魔法校路由跳转
    if (category === 'mofaxiao') {
      // 初始化扬帆用户
      console.log('commonlink--1')
      await authApi.generateOceanUser()
      console.log('commonlink--2')
      if (location.href.indexOf('redirectUrl') > -1) {
        let path = options.query.redirectUrl
        let query = JSON.parse(localStorage.getItem('redirectParams'))
        link.push({ path, query })
      } else if (options.query.to_activity_detail) { // 需要跳到活动详情的情况
        let url = '/activityDetail' + location.search.replace('&to_activity_detail=1', '')
        linkRouter(link, url)
      } else if (options.query.toTaskList) {
        let url = '/mschool/taskList' + location.search.replace('&toTaskList=1', '')
        linkRouter(link, url)
      } else if (options.query.toLivingDetail) {
        let url = '/mschool/livingDetail' + location.search.replace('&toLivingDetail=1', '')
        linkRouter(link, url)
      } else if (options.query.redirectEncodedFullPath) {
        let url = decodeURIComponent(options.query.redirectEncodedFullPath)
        if (/(http|https):\/\/([\w.]+\/?)\S*/.test(url)) {
          location.href = url
          return
        }
        linkRouter(link, url)
      } else {
        if (getPermissions('mall').length > 0) {
          if (getPermissions('school_manage').includes('直播平台')) {
            linkRouter(link, '/schoolManage')
          } else if (getUser().is_wlhk_test) {
            // linkRouter(link, '/mall')
            console.log('commen link /mall')
            location.href = '/mall'
          } else {
            linkRouter(link, '/')
          }
        } else if (getPermissions('school_manage').length > 0) {
          linkRouter(link, '/schoolManage')
        } else if (getPermissions('contentCenter').length > 0) {
          linkRouter(link, '/contentCenter/evaluation')
        } else if (
          getLearnPermissions() || getMarketCenterPermissions()
        ) {
          linkRouter(link, '/')
        } else {
          linkRouter(link, {
            name: 'auth.setProfile',
            query: {
              loggedIn: true
            }
          })
        }
      }
    } else {
    // 直播云路由跳转
      if (getPermissions('mall').length > 0) {
        if (getPermissions('school_manage').includes('直播平台')) {
          linkRouter(link, '/schoolManage')
        } else {
          linkRouter(link, '/')
        }
      } else if (getPermissions('school_manage').length > 0) {
        linkRouter(link, '/schoolManage')
      } else if (
        getLearnPermissions()
      ) {
        linkRouter(link, '/')
      } else {
        linkRouter(link, {
          name: 'auth.setProfile',
          query: {
            loggedIn: true
          }
        })
      }
    }
  })
}
